import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Input } from '../../../../../CommonComponents/OPL/Input/Input';
import { StepCard } from '../../StepCard/StepCard';

export const SIMPLE_IRA_PLAN_NAME = 'simplePlanName';

export interface SimpleIraPlanNameFormField {
  [SIMPLE_IRA_PLAN_NAME]?: string;
}

export const SimpleIraPlanName = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<SimpleIraPlanNameFormField>();

  return (
    <StepCard>
      <Text color="neutral.700" fontSize="h3" fontWeight={500}>
        What is your Simple IRA plan name?
      </Text>

      <Box mt="32" width="100%">
        <Input
          {...register(SIMPLE_IRA_PLAN_NAME)}
          label="Plan Name"
          formVariant={errors[SIMPLE_IRA_PLAN_NAME] ? 'error' : undefined}
          helperText={errors[SIMPLE_IRA_PLAN_NAME]?.message}
        />
      </Box>
    </StepCard>
  );
};
